import React from "react";
import { Box, Button, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { exitDemo, isDemoMode } from "../../demo/core";
import { clearZeroDemoPreferences } from "../../demo/session";

/** Zero accent (DESIGN.md). */
const DEMO_ACCENT = "#7C3AED";

/** Thin sticky "Demo mode" bar with an Exit button; renders nothing outside demo mode. */
const DemoBanner: React.FC = () => {
  const { t } = useTranslation();
  if (!isDemoMode()) return null;

  const handleExit = () => {
    clearZeroDemoPreferences();
    exitDemo();
  };

  return (
    <Box
      role="status"
      sx={{
        position: "sticky",
        top: { xs: 56, sm: 0 },
        zIndex: (theme) => theme.zIndex.appBar - 1,
        minHeight: 36,
        bgcolor: DEMO_ACCENT,
        color: "#FFFFFF",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexWrap: "wrap",
        columnGap: 2,
        rowGap: 0.5,
        px: 2,
        py: 0.5,
      }}
    >
      <Typography variant="body2" sx={{ fontWeight: 600, color: "inherit" }}>
        {t("demo.banner")}
      </Typography>
      <Button
        variant="outlined"
        color="inherit"
        size="small"
        onClick={handleExit}
        sx={{ py: 0.25, px: 1.25, minHeight: 0, lineHeight: 1.5, borderColor: "rgba(255,255,255,0.7)" }}
      >
        {t("demo.exit")}
      </Button>
    </Box>
  );
};

export default DemoBanner;
